import { BRAIN_TOPICS_CAMERA_SETTINGS } from "../../config/mqtt_config";

const REMOTE_CLIENT_DEBUG_ENABLED = process.env.NODE_ENV !== "test";

export function isRemoteClientDebugEnabled() {
  return REMOTE_CLIENT_DEBUG_ENABLED;
}

export function logRemoteClientDebug(
  message: string,
  payload?: Record<string, any>,
) {
  if (!REMOTE_CLIENT_DEBUG_ENABLED) {
    return;
  }

  if (payload) {
    console.log(`[AdRemoteClient] ${message}`, payload);
    return;
  }

  console.log(`[AdRemoteClient] ${message}`);
}

export function logRemoteClientEvent(
  eventName: string,
  payload?: Record<string, any>,
) {
  logRemoteClientDebug(eventName, payload);
}

function normalizeTopicForDebug(topic: string): string {
  return topic.replace(/^\/+/, "").replace(/-/g, "_");
}

function isFrontCameraSettingsTopic(topic: string): boolean {
  const normalizedTopic = normalizeTopicForDebug(topic);
  const normalizedConfiguredTopic = normalizeTopicForDebug(
    BRAIN_TOPICS_CAMERA_SETTINGS.FRONT,
  );

  return (
    normalizedTopic === normalizedConfiguredTopic ||
    normalizedTopic === "media/front_cam/settings" ||
    normalizedTopic === "media/front_camera/settings"
  );
}

function buildKeyValueListDebugValue(data: any) {
  if (!Array.isArray(data?.list)) {
    return [];
  }

  return data.list.map((item: any) => ({
    key: item?.key,
    value: item?.value,
    type: item?.type,
  }));
}

export function logFrontCameraSettingsDebug(
  decoded: Record<string, any>,
  envelopePayloadByteLength: number,
): void {
  if (!isFrontCameraSettingsTopic(String(decoded.topic || ""))) {
    return;
  }

  console.log("[AdRemoteClient] Front camera settings data channel payload", {
    topic: decoded.topic ?? null,
    typeName: decoded.typeName ?? null,
    envelopePayloadByteLength,
    decodedKeyValueArray: decoded.data ?? null,
    list: buildKeyValueListDebugValue(decoded.data),
  });
}
